import { COUNTRY } from '@/config';

const AGENT_URL_CREATE = {
  br: `${window.location.origin}/agente/criar`,
  es: `${window.location.origin}/agente/crear`,
};

export const AGENT_FACTORY_URL = AGENT_URL_CREATE[COUNTRY];
